/**
 * The action status and priority vocabularies, in a module that imports
 * nothing.
 *
 * Same bundle decision as `offer-vocabulary.ts`: `router.tsx` imports every
 * route's `validateSearch` schema EAGERLY, so what a search module reaches for
 * lands in the initial chunk. Both `my-actions.route.search.ts` and
 * `workspace-actions.route.search.ts` filter on these two, and reaching for the
 * Zod enums dragged `create-action.schema.ts`, its three create bodies and its
 * discriminated union included, into the initial chunk.
 *
 * The tuples are the single source of truth: `create-action.schema.ts` builds
 * `actionStatusSchema` and `prioritySchema` from them, so the URL parser and
 * the wire parser cannot drift.
 */

export const ACTION_STATUSES = [
  "suggested",
  "accepted",
  "in_progress",
  "completed",
  "measured",
  "closed",
  "dismissed",
] as const;
export type ActionStatusName = (typeof ACTION_STATUSES)[number];

export const ACTION_PRIORITIES = ["low", "medium", "high", "critical"] as const;
export type ActionPriorityName = (typeof ACTION_PRIORITIES)[number];
